import React from "react";
import Blog from "../components/blog/blog_content";
import Footer from "../components/footer";
import HeaderAny from "../components/header";
import MobileNav from "../components/header-mobile";

const BlogPage = () => {
  return (
    <div className="">
      <div>
        <div className="web-only">
          <HeaderAny />
        </div>
        <div className="mobile-only">
          <MobileNav />
        </div>
      </div>
      <Blog />
      <Footer />
    </div>
  );
};

export default BlogPage;
